import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputForm from "../forms/inputForm";
import SelectForm from "../forms/selectFormm";
import { useAppDispatch } from "../../../store";
import { useEffect, useState } from "react";
import useDebouncedEffect from "../../../hooks/useDebouncedEffect";
import DatePickerForm from "../forms/datePickerForm";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { setPageKey } from "../../../store/feature/reducers/roleReducer";

const schema = yup.object({
  title: yup.string().required(),
});

const CompanySearch = ({ params, setParams }: any) => {
  const [searchFilterDebounced, setSearchFilterDebounced] = useState("");
  const [cmpnyName, setCmpnyName] = useState("");
  const [industry, setIndustry] = useState("");
  const [cmpnyEmail, setCmpnyEmail] = useState("");

  // const [status, setStatus] = useState("");
  const [enrolledStart, setEnrolledStart] = useState("");
  const [enrolledEnd, setEnrolledEnd] = useState("");
  const [userActive, setUserActive] = useState(""); // TODO: NEED PARAMETER FROM API
  const dispatch = useAppDispatch();

  const {
    control,
    reset,
    formState: { errors },
  } = useForm<{
    cmpnyName: string;
    industry: string;
    cmpnyEmail: string;
    enrolledStart: string;
    enrolledEnd: string;
  }>({
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      cmpnyName: "",
      industry: "",
      cmpnyEmail: "",
      enrolledStart: "",
      enrolledEnd: "",
    },
  });

  const statusDropdown = [
    {
      label: "Active",
      value: "active",
    },
    {
      label: "Inactive",
      value: "inactive",
    },
  ];

  const handleCmpnyName = (e: string) => {
    setCmpnyName(e);
  };
  const handleIndustry = (e: string) => {
    setIndustry(e);
  };
  const handleCmpnyEmail = (e: string) => {
    setCmpnyEmail(e);
  };
  // const handleStatusSelect = (e: any) => { setUserActive(e.value); };
  const handleEnrolledStart = (e: any) => {
    let NewDate: any;
    if (e !== null) {
      NewDate = dayjs(e).format("YYYY-MM-DD");
      if (dayjs(e).isAfter(dayjs(enrolledEnd))) {
        setAllDate(NewDate);
      } else {
        setEnrolledStart(NewDate);
      }
    } else {
      NewDate = "";
      setAllDate(NewDate);
    }
  };
  const setAllDate = (date: string) => {
    reset({
      // deviceId: deviceId,
      // hostname: hostname,
      // enrolledStart: date,
      // enrolledEnd: date,
      // status: userActive,
      cmpnyName,
      industry,
      cmpnyEmail,
      enrolledStart: date,
      enrolledEnd: date,
    });
    setEnrolledStart(date);
    setEnrolledEnd(date);
  };
  const handleEnrolledEnd = (e: any) => {
    let NewDate: any;
    if (e !== null) {
      NewDate = dayjs(e).format("YYYY-MM-DD");
    } else {
      NewDate = "";
    }
    if (conditionCheck()) setEnrolledEnd(NewDate);
  };
  const conditionCheck = () => {
    if (enrolledStart === "") {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: "Please select Start Created",
      });
      reset({
        // deviceId: deviceId,
        // hostname: hostname,
        // enrolledStart: "",
        // enrolledEnd: "",
        // status: userActive,
        cmpnyName,
        industry,
        cmpnyEmail,
        enrolledStart: "",
        enrolledEnd: "",
      });
      setEnrolledEnd("");
      return false;
    } else {
      return true;
    }
  };

  useDebouncedEffect(
    () => setSearchFilterDebounced(cmpnyName),
    [cmpnyName],
    500
  );
  useDebouncedEffect(() => setSearchFilterDebounced(industry), [industry], 500);
  useDebouncedEffect(() => setSearchFilterDebounced(cmpnyEmail), [cmpnyEmail], 500);
  useDebouncedEffect(
    () => setSearchFilterDebounced(userActive),
    [userActive],
    500
  );
  useDebouncedEffect(
    () => setSearchFilterDebounced(enrolledStart),
    [enrolledStart],
    500
  );
  useDebouncedEffect(
    () => setSearchFilterDebounced(enrolledEnd),
    [enrolledEnd],
    500
  );

  useEffect(() => {
    setParams({
      ...params,
      name: cmpnyName,
      industry: industry,
      email: cmpnyEmail,
      created_from: enrolledStart,
      created_to: enrolledEnd,
    });
    dispatch(setPageKey(cmpnyName || industry || cmpnyEmail || enrolledStart || enrolledEnd));
  }, [searchFilterDebounced]);

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "row", gap: "1rem", flex: 1 }}>
        <InputForm
          name="cmpnyName"
          errors={errors}
          control={control}
          required
          placeholder="Company Name"
          maxLength={100}
          isLoading={false}
          onChange={handleCmpnyName}
        />
        <InputForm
          name="industry"
          errors={errors}
          control={control}
          required
          placeholder="Industry"
          maxLength={100}
          isLoading={false}
          onChange={handleIndustry}
        />
        <InputForm
          name="cmpnyEmail"
          errors={errors}
          control={control}
          required
          placeholder="Company Email"
          maxLength={100}
          isLoading={false}
          onChange={handleCmpnyEmail}
        />
        <DatePickerForm
          name="enrolledStart"
          defaultValue={null}
          control={control}
          errors={errors}
          placeholder="Updatted From"
          disabled={false}
          isLoading={false}
          required
          onChange={handleEnrolledStart}
        />
        <DatePickerForm
          name="enrolledEnd"
          defaultValue={null}
          control={control}
          errors={errors}
          placeholder="Updatted to"
          disabled={false}
          isLoading={false}
          required
          onChange={handleEnrolledEnd}
        />
        {/* <SelectForm
          name="status"
          defaultValue={1}
          options={statusDropdown}
          placeholder="Status"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          required
          sxFL={{ backgroundColor: "red" }}
          onChangeForm={handleStatus}
          isClear
        /> */}
      </Box>
    </Box>
  );
};

export default CompanySearch;
